module.exports = __webpack_public_path__ + "static/media/navbar-img-4.cc57986b.jpg";